import { QuizMutations } from './mutations';
import { ActionContext } from 'vuex';
import { QuizState } from '@/models/QuizState';
import { AppState } from '@/models/SkillAssessmentAppState';
import { STATE_MODULES } from "@/store/state-modules";
import { AnsweredQuestion } from '@puls/puls-common-constants';
import axios from 'axios';
import config from '@/config';
import { QuizGetters } from './getters';
import { generateNotificationItem, NOTIFICATION_TYPES } from '@/models/AppConfig';
import { ConfigMutations } from '../config/mutations';

export const QuizActions = {
	LOAD_QUIZ_MAPPING: 'LOAD_QUIZ_MAPPING',
	ANSWER_QUESTION: 'ANSWER_QUESTION',
	START_QUIZ: 'START_QUIZ',
	SUBMIT_ANSWER: 'SUBMIT_ANSWER',
	RETRY_QUIZ: 'RETRY_QUIZ',
	EXPIRE_QUIZ: 'EXPIRE_QUIZ'
}

const IS_LOCAL = window.location.hostname === 'localhost';

export interface AnswerQuestionPayload {
	uuid: string,
	answers: string[]
}

export default {
	[QuizActions.LOAD_QUIZ_MAPPING] (context: ActionContext<QuizState, AppState>) {
		if (IS_LOCAL) {
			import('./test-data').then(async (module) => {
				try {
					const result: any = await module.default();
					context.commit(`${STATE_MODULES.QUIZ}/${QuizMutations.UPDATE_QUIZ_MAPPING}`, result.data.data, { root: true });	
				} catch (error: any) {
					// eslint-disable-next-line
					console.error(error.message);
				}
			}).catch(err => {
				// eslint-disable-next-line 
				console.error('You probebly didnt run the right script!!!', err.message);
			})
		} else {
			const data = document.getElementById("server-skill-assessment-quiz")?.innerText || '';
			context.commit(`${STATE_MODULES.QUIZ}/${QuizMutations.UPDATE_QUIZ_MAPPING}`, JSON.parse(data), { root: true });	
		}
	},
	[QuizActions.ANSWER_QUESTION] (context: ActionContext<QuizState, AppState>, payload: AnswerQuestionPayload) {
		context.commit(`${STATE_MODULES.QUIZ}/${QuizMutations.UPDATE_QUESTION_ANSWER}`, payload, { root: true });
	},
	async [QuizActions.SUBMIT_ANSWER] (context: ActionContext<QuizState, AppState>, payload: { uuid: string }) {
		const currentQuestion = context.getters[QuizGetters.GET_QUESTION_BY_UUID](payload.uuid) as AnsweredQuestion;
		if (!currentQuestion) {
			return;
		}

		try {
			const result = await axios.post(`${config.webapi}/api/technician/skill-assessment/quiz/attempt/submit-question`, {
				question_uuid: payload.uuid,
				answers: currentQuestion.answers
			})
			
			context.commit(`${STATE_MODULES.QUIZ}/${QuizMutations.UPDATE_QUIZ_MAPPING}`, result.data.data, { root: true });	
		} catch (error: any) {
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: error.message }),
				{ root: true }
			);
		}
	},
	async [QuizActions.START_QUIZ] (context: ActionContext<QuizState, AppState>) {
		try {
			const result = await axios.get(`${config.webapi}/api/technician/skill-assessment/quiz/attempt/start`)
			context.commit(`${STATE_MODULES.QUIZ}/${QuizMutations.UPDATE_QUIZ_MAPPING}`, result.data.data, { root: true });	
		} catch (error: any) {
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: error.message }),
				{ root: true }
			);
		}
	},
	async [QuizActions.RETRY_QUIZ] (context: ActionContext<QuizState, AppState>) {
		try {
			const result = await axios.get(`${config.webapi}/api/technician/skill-assessment/quiz/attempt/retry`)
			context.commit(`${STATE_MODULES.QUIZ}/${QuizMutations.UPDATE_QUIZ_MAPPING}`, result.data.data, { root: true });	
		} catch (error: any) {
			context.commit(
				`${STATE_MODULES.CONFIG}/${ConfigMutations.ADD_NOTIFICATION}`,
				generateNotificationItem({ type: NOTIFICATION_TYPES.error, message: error.message }),
				{ root: true }
			);
		}
	},
	[QuizActions.EXPIRE_QUIZ] (context: ActionContext<QuizState, AppState>) {
		context.commit(`${STATE_MODULES.QUIZ}/${QuizMutations.EXPIRE_CURRENT_QUIZ}`, {}, { root: true });	
	}
}
